import { Flex, IconFont, Text } from '@byecode/ui'
import type { PageAbstract } from '@lighthouse/core'
import React from 'react'
import styled from 'styled-components'

interface SearchPageListProps {
    list: (PageAbstract & { path?: string })[]
    activeId?: string
    onToLink?: (page: PageAbstract) => void
}

const SCxContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 8px;
`

const SCxItem = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    /* gap: 8px; */
    padding: 6px 8px;
    line-height: 22px;
    font-size: 14px;
    border-radius: 8px;
    cursor: pointer;
    &:hover {
        background-color: var(--color-gray-100);
    }
    &.active {
        background-color: var(--color-gray-100);
    }
`
export const SearchPageList: React.FunctionComponent<SearchPageListProps> = ({ activeId, list, onToLink }) => {
    return (
        <SCxContainer>
            {list.map((page, index) => (
                <SCxItem key={page.id} className={activeId === page.id ? 'active' : undefined} onClick={() => onToLink?.(page)}>
                    <Flex alignItems="center" gap={6}>
                        <IconFont type="PageBroadContent" color="var(--color-gray-400)" size={16} />
                        <Text>{page.name}</Text>
                    </Flex>
                    {page.path && (
                        <Text style={{ paddingLeft: 22 }} size={12} color="var(--color-gray-500)">
                            {page.path}
                        </Text>
                    )}
                </SCxItem>
            ))}
        </SCxContainer>
    )
}
